/**
 * Free Gift with Purchase
 * Adds a free gift when items are added to cart.
 * Works with Shopify automatic discount to make the item free.
 */

(function () {
  'use strict';

  // @ts-ignore
  const config = window['FreeGiftConfig'];
  if (!config || !config.enabled || !config.variantId) return;

  const variantId = config.variantId.toString();
  const message = config.message || '🎁 Free gift added to your order!';
  let isAdding = false;

  /** @returns {Promise<{items: Array<{variant_id: number, properties?: Record<string, string>}>}>} */
  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  /**
   * @param {string} msg
   */
  function showNotification(msg) {
    const existing = document.querySelector('.free-gift-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'free-gift-toast free-gift-toast--visible';
    toast.innerHTML = `<div class="free-gift-toast__content"><span>${msg}</span></div>`;
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 4000);
  }

  async function addFreeGiftAndRefresh() {
    if (isAdding) return;
    isAdding = true;

    try {
      // Get section IDs for the cart drawer
      const cartDrawerEl = document.querySelector('cart-drawer-component');
      const sectionId = (cartDrawerEl instanceof HTMLElement && cartDrawerEl.dataset?.sectionId) || 'cart-drawer';

      // Add free gift with section rendering
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: { '_free_gift': 'true' } }],
          sections: sectionId
        })
      });

      if (!res.ok) return;

      const data = await res.json();
      showNotification(message);

      // Update cart drawer with new HTML
      if (data.sections && data.sections[sectionId]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data.sections[sectionId], 'text/html');
        const newContent = doc.querySelector('cart-drawer-component');
        const currentDrawer = document.querySelector('cart-drawer-component');

        if (newContent && currentDrawer) {
          // Replace inner content to preserve the open state
          const newInner = newContent.querySelector('.cart-drawer');
          const currentInner = currentDrawer.querySelector('.cart-drawer');
          if (newInner && currentInner) {
            currentInner.innerHTML = newInner.innerHTML;
          }
        }
      }

      // Also update cart count in header
      const cartCount = document.querySelectorAll('.cart-count, [data-cart-count]');
      const cart = await getCart();
      cartCount.forEach(el => {
        el.textContent = cart.items?.length?.toString() || '0';
      });

    } catch (e) {
      console.error('Free gift error:', e);
    } finally {
      isAdding = false;
    }
  }

  async function checkCart() {
    try {
      const cart = await getCart();
      if (!cart.items?.length) return false;

      const hasGift = cart.items.some(i =>
        i.variant_id.toString() === variantId && i.properties?.['_free_gift'] === 'true'
      );

      // Check if cart only contains bundle products (MBC Bundles creates products with "bundle" in handle/title)
      /**
       * @param {{product_title?: string, handle?: string, product_handle?: string, [key: string]: any}} item
       */
      const isBundleProduct = (item) => {
        const productTitle = (item.product_title || '').toLowerCase();
        const productHandle = (item.handle || item.product_handle || '').toLowerCase();
        return productTitle.includes('bundle') || productHandle.includes('bundle');
      };

      // Filter out the free gift to check what other items are in cart
      const otherItems = cart.items.filter(item =>
        !(item.variant_id.toString() === variantId && item.properties?.['_free_gift'] === 'true')
      );

      // If cart only has bundles (and no other products), don't add free gift
      if (otherItems.length > 0 && otherItems.every(item => isBundleProduct(item))) {
        return false;
      }

      // Check if there are other qualifying products (not the free gift, not bundles)
      const hasOther = otherItems.some(i => !isBundleProduct(i));

      return !hasGift && hasOther;
    } catch { return false; }
  }

  // Check on page load
  setTimeout(async () => {
    if (await checkCart()) await addFreeGiftAndRefresh();
  }, 500);

  // Listen for successful cart additions via fetch interception
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    // Check if this was a cart add (not our own)
    const url = args[0]?.toString() || '';
    if (url.includes('/cart/add') && !isAdding) {
      // Wait for response to complete, then check if we need to add gift
      setTimeout(async () => {
        if (await checkCart()) await addFreeGiftAndRefresh();
      }, 300);
    }

    return response;
  };

})();

